<template>
  <div ref="chart" class="tabs" v-show="position.show">
    <div :style="{ width: `${width || position.w}px`, height: `${height || position.y}px` }">
      <div :style="{ height: `${option.style.height}px` }">
        <div
          :style="{
            lineHeight: `${option.style.height}px`,
            paddingLeft: `${option.style.paddingLeft}px`
          }"
        >
          <span
            class="tab-header"
            v-for="(item, index) in option.tabList"
            :key="item.key"
            :style="{
              fontSize:
                activeIndex === index ? `${option.style.active.fontSize}px` : `${option.style.default.fontSize}px`,
              fontWeight:
                activeIndex === index ? `${option.style.active.fontWeight}` : `${option.style.default.fontWeight}`,
              color: activeIndex === index ? option.style.active.color : option.style.default.color,
              width: `${option.style.width}px`,
              marginRight: `${option.style.marginRight}px`,
              backgroundImage:
                activeIndex === index
                  ? `url(${option.style.active.backgroundImage})`
                  : `url(${option.style.default.backgroundImage})`,
              backgroundSize: '100% 100%',
              // backgroundColor: 'rgba(177,190,200,0.8)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }"
            @click="handleTabClick(index)"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
      <div class="tabCon" :style="{ height: `calc(100% - ${option.style.height}px )` }">
        <template v-for="(tab, idx) in option.tabList">
          <div class="content-item" :key="idx" v-if="idx === activeIndex">
            <vue-drag
              v-for="item in tab.dragList"
              :snap="true"
              :parent="true"
              :min-width="20"
              :key="item.iid"
              :snapTolerance="10"
              :active.sync="item.position.active"
              :x="item.position.x || 0"
              :y="item.position.y || 0"
              :z="item.position.z || 0"
              :w="item.position.w || 'auto'"
              :h="item.position.h || 'auto'"
              :overView="true"
              :class-name="'custome-drag'"
            >
              <div class="drag-title" v-if="item.position.active">
                <span>{{ item.position.title }}</span>
              </div>
              <Echarts
                :ref="item.iid"
                :iid="item.iid"
                :option="item.option"
                :position="item.position"
                v-if="item.components.indexOf('ChartConfig') != -1"
                :chartType="item.components"
                :customChartData="item.components === 'CustomChartConfig' ? item.data : []"
                :customChartJs="item.components === 'CustomChartConfig' ? item.jsTxt : ''"
              />
              <Texts
                :ref="item.iid"
                v-if="item.components === 'TextConfig'"
                :option="item.option"
                :position="item.position"
              />
              <Picture
                :ref="item.iid"
                v-if="item.components === 'PicConfig'"
                :option="item.option"
                :position="item.position"
              />
              <Iframe
                :ref="item.iid"
                v-if="item.components === 'IframeConfig'"
                :option="item.option"
                :position="item.position"
                :title="''"
              />
              <Tabs
                :ref="item.iid"
                v-if="item.components === 'TabsConfig'"
                :option="item.option"
                :position="item.position"
              />
              <NavList
                :ref="item.iid"
                v-if="item.components === 'NavListConfig'"
                :option="item.option"
                :position="item.position"
              />
              <FlipNumber
                :ref="item.iid"
                v-if="item.components === 'FlipperConfig'"
                :option="item.option"
                :position="item.position"
              />
              <List
                :ref="item.iid"
                v-if="item.components === 'ListConfig'"
                :option="item.option"
                :position="item.position"
              />
            </vue-drag>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { VueDrag } from '@/components'
import { Picture, Texts, NavList, Iframe, Echarts, FlipNumber, List } from '@/common'

export default {
  name: 'Tabs',
  data() {
    return {
      activeIndex: this.option.activeIndex || 0,
      width: null,
      height: null,
      scale: 1
    }
  },
  components: {
    Picture,
    Texts,
    Iframe,
    NavList,
    VueDrag,
    Echarts,
    FlipNumber,
    List
  },
  props: {
    option: {
      // 配置参数包括数据
      type: Object,
      default() {
        return {}
      }
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleTabClick(index) {
      this.activeIndex = index
    }
  }
}
</script>
<style lang="less" scoped>
.tabs {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.tab-header {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}

.tabCon {
  position: relative;
  margin: 0 auto;
  color: #999;
  font-size: 14px;
  .content-item {
    height: 100%;
  }
}
.drag-title {
  z-index: 9999;
  position: absolute;
  left: 0;
  font-size: 12px;
  color: red;
  background-color: #fafafa;
}
.custome-drag {
  border: none;
}
</style>
